const exported = {
    PAGEVIEW_TRACKING: "Track Request - PV",
};

export default exported;

export const { PAGEVIEW_TRACKING } = exported;
